<form
    #form
    fsForm
    [submit]="save"
    *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <h1>
      Name Your Specify Workspace
    </h1>
    <p>
      This could be the name of your company or organization
    </p>
    <mat-form-field class="full-width">
      <mat-label>
        Workspace Name
      </mat-label>
      <input
        matInput
        [(ngModel)]="environmentCreate.workspaceName"
        fsFormRequired
        name="workspace_name"
        autoFocus1>
      <mat-hint>
        This can be changed later
      </mat-hint>
    </mat-form-field>
  </mat-card-content>
  <mat-card-actions>
    <button
        type="submit"
        mat-flat-button
        color="primary"
        class="full-width">
      Continue
    </button>
  </mat-card-actions>
</form>